/**
 * @generated SignedSource<<c899466da4a46b993ea7389392edf895>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BulkTransfer_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly displayName: string;
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly displayName: string;
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly " $fragmentType": "BulkTransfer_metadata";
};
export type BulkTransfer_metadata$key = {
  readonly " $data"?: BulkTransfer_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkTransfer_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "StackedAssetMedia_assets"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BulkTransfer_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "491d18095a7ebd6a3e665f91745037ac";

export default node;
